export const PasswordValidationStatus = ({password}: {password: string}) => {
  const validations = [
    {
      label: "Uppercase letter",
      isValid: /[A-Z]/.test(password),
      description: "Include at least one uppercase letter (A-Z)",
    },
    {
      label: "Number (0-9)",
      isValid: /\d/.test(password),
      description: "Include at least one number",
    },
    {
      label: "Special character",
      isValid: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      description: "Include at least one special character (!@#$% etc.)",
    },
    {
      label: "Minimum 8 characters",
      isValid: password.length >= 8,
      description: "Your password should be at least 8 characters long",
    },
  ];

  return (
    <div className="!mt-2">
      <div className="!flex !flex-wrap !gap-2">
        {password.length > 0 && (
          <div className="!mt-3 !w-full !bg-gray-100 !rounded-full !h-1.5">
            <div
              className={`h-full rounded-full ${
                validations.every((v) => v.isValid)
                  ? "bg-green-500"
                  : validations.filter((v) => v.isValid).length >= 2
                  ? "bg-yellow-100"
                  : "bg-alert-error-100"
              }`}
              style={{
                width: `${
                  (validations.filter((v) => v.isValid).length /
                    validations.length) *
                  100
                }%`,
              }}
            />
          </div>
        )}
        {validations.map((validation, index) => (
          <div
            key={index}
            className="group relative"
            aria-label={validation.description}
          >
            <div
              key={index}
              className={`flex items-center gap-2 py-1 px-2 rounded-2xl ${
                validation.isValid ? "bg-green-25" : "bg-gray-25"
              }`}
            >
              <div
                className={`w-2 h-2 rounded-full ${
                  validation.isValid ? "bg-green-500" : "bg-gray-300"
                }`}
              />
              <p
                className={`text-xs ${
                  validation.isValid ? "text-green-700" : "text-gray-500"
                }`}
              >
                {validation.label}
              </p>
            </div>
            <div className="absolute z-10 hidden group-hover:block bg-gray-50 text-gray-500 border border-dashed text-xs p-2 rounded mt-1 w-max">
              {validation.description}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
